import callApi from 'lib/callApi';

export async function fetchAccountDetail(id, companyId) {
  let url = `sast/accounts/${id}/`;
  const params = {
    company_id: companyId,
  };
  const data = await callApi(url, 'GET', params)
    .then((res) => {
      if (res.data) {
        return res.data;
      }
    })
    .catch((err) => {
      throw err;
    });
  return data;
}

export const processJsonData = (json: any) => {
  if (!json) return;

  // process fullname
  let fullname: any = null;
  if (json['user'] && json['user']['first_name'] && json['user']['last_name']) {
    fullname = `${json['user']['first_name']} ${json['user']['last_name']}`;
  }

  let deactivatedByFullName: any = null;
  if (
    json['deactivated_by'] &&
    json['deactivated_by']['first_name'] &&
    json['deactivated_by']['last_name']
  ) {
    deactivatedByFullName = `${json['deactivated_by']['first_name']} ${json['deactivated_by']['last_name']}`;
  }

  let reactivatedByFullName: any = null;
  if (
    json['reactivated_by'] &&
    json['reactivated_by']['first_name'] &&
    json['reactivated_by']['last_name']
  ) {
    reactivatedByFullName = `${json['reactivated_by']['first_name']} ${json['reactivated_by']['last_name']}`;
  }

  const processedJson = {
    ...json,
    user: {
      ...json['user'],
      fullname: fullname,
    },
    deactivated_by: {
      ...json['deactivated_by'],
      fullname: deactivatedByFullName,
    },
    reactivated_by: {
      ...json['reactivated_by'],
      fullname: reactivatedByFullName,
    },
  };

  return processedJson;
};
